import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { approvedIcon } from '@/constants/images';
import WarningPopup from '@/components/WarningPopup';
import DropdownItem from '@/components/DropdownItem';

const UserApproveTool = ({
  approved,
  divider,
  isCurrentUser,
  onClick,
}) => (
  <>
    {divider && (<Dropdown.Divider />)}
    <WarningPopup disabled={!isCurrentUser}>
      <DropdownItem
        icon={approvedIcon(!approved)}
        textId={approved ? 'actions.unapprove' : 'actions.approve'}
        onClick={onClick}
      />
    </WarningPopup>
  </>
);

export default UserApproveTool;
